import React from "react";

export default ({ children }) => {
	return <div id="session-container">{children}</div>;
};
